<template>
  <div>
    <b-card-body>
      <b-card class="user-password">
        <b-form submit.stop.prevent="save">
          <!-- <p><b>ALTERAÇÃO DE SENHA</b></p>
          <BR /> -->
          <b-row>
            <b-col md="10" sm="12">
              <b-form-group :label="$t('nome-0')" label-for="user-username">
                <b-form-input
                  class="input-pentagro"
                  id="user-username"
                  type="text"
                  v-model="user.FullName"
                  :readonly="true"
                  :placeholder="$t('informe-o-nome-do-usuario')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col sm="12">
              <b-form-group :label="$t('senha-antiga')" label-for="user-old-password">
                <b-form-input
                  class="input-pentagro"
                  id="user-old-password"
                  type="password"
                  v-model="passwords.oldPassword"
                  name="validateOldPassword"
                  v-validate="{
                    required: true,
                    min: 4,
                    max: 20
                  }"
                  :state="validateState('validateOldPassword')"
                  aria-describedby="validateOldPassword-feedback"
                  :data-vv-as="$t('senha-antiga-0')"
                  :placeholder="$t('informe-a-senha-de-usuario-antiga')"
                />
                <b-form-invalid-feedback id="validateOldPassword-feedback">{{
                  veeErrors.first("validateOldPassword")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('nova-senha')" label-for="user-password">
                <b-form-input
                  class="input-pentagro"
                  id="user-password"
                  type="password"
                  v-model="passwords.newPassword"
                  name="validateNewPassword"
                  v-validate="{
                    required: true,
                    min: 4,
                    max: 20
                  }"
                  :state="validateState('validateNewPassword')"
                  aria-describedby="validateNewPassword-feedback"
                  :data-vv-as="$t('nova-senha-0')"
                  :placeholder="$t('informe-a-nova-senha-de-usuario')"
                />
                <b-form-invalid-feedback id="validateNewPassword-feedback">{{
                  veeErrors.first("validateNewPassword")
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                :label="$t('confirmacao-da-nova-senha')"
                label-for="user-confirm-password"
              >
                <b-form-input
                  class="input-pentagro"
                  id="user-confirm-password"
                  type="password"
                  v-model="passwords.confirmPassword"
                  name="validateConfirmNewPassword"
                  v-validate="{
                    required: true,
                    min: 4,
                    max: 20,
                    is: passwords.newPassword
                  }"
                  :state="validateState('validateConfirmNewPassword')"
                  aria-describedby="validateConfirmNewPassword-feedback"
                  :data-vv-as="$t('confirmar-nova-senha')"
                  :placeholder="$t('confirme-a-nova-senha-de-usuario')"
                />
                <b-form-invalid-feedback
                  id="validateConfirmNewPassword-feedback"
                  >{{
                    veeErrors.first("validateConfirmNewPassword")
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <div>
              <img
                src="@/assets/salvar.png"
                alt="salvar"
                style="margin-left: 30px;"
                :title="$t('salvar')"
                @click="save"
              />
              <img
                class="eraser"
                src="@/assets/apagar.png"
                style="margin-left: 30px;"
                :title="$t('limpar')"
                alt="limpar"
                @click="resetForm"
              />
              <img
                id="closeModalPassword"
                class="float-right"
                src="@/assets/sair.png"
                style="margin-left: 30px;"
                :title="$t('cancelar')"
                alt="cancelar"
                @click="$bvModal.hide('modalPassword')"
              />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "UserPassword",
  data: function() {
    return {
      passwords: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  computed: mapState(["user"]),
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    save() {
      /* eslint-disable */
      // console.log("entrou save changePassword");
      var md5 = require("md5");
      this.$validator.validateAll().then(result => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        } else {
          // if (this.passwords.newPassword != this.passwords.confirmPassword) {
          //   showError("Confirmação de senha incorreta !");
          //   return;
          // }
          // else {
          this.passwords.oldPassword = md5(this.passwords.oldPassword);
          this.passwords.newPassword = md5(this.passwords.newPassword);
          let obj = {};
          obj.userId = parseInt(this.user.Id);
          obj.unitId = parseInt(this.user.UnitId);
          obj.system = this.user.role == "GDI" ? "G": "P";
          obj.oldPassword = this.passwords.oldPassword;
          obj.newPassword = this.passwords.newPassword;
          // console.log(obj);
          obj.oldPassword = window.btoa(JSON.stringify(obj.oldPassword));
          obj.newPassword = window.btoa(JSON.stringify(obj.newPassword));
          this.passwords.confirmPassword = this.passwords.newPassword;
          // console.log(JSON.stringify(obj));
          axios["post"](`${urlMainAPI}/changepassword`, obj) //axios ... método chamado por string
            .then(res => {
              // console.log(obj);
              defaultSuccess(res.data);
              this.$nextTick(() => {
                this.$validator.reset();
              });
              //this.$toasted.global.defaultSuccess();
              this.reset();
            })
            .catch(() => {
              this.resetForm();
            });
          // }
        }
      });
    },
    resetForm() {
      // console.log("entrei resetForm");
      this.passwords.oldPassword = null;
      this.passwords.newPassword = null;
      this.passwords.confirmPassword = null;
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    reset() {
      this.passwords.oldPassword = "";
      this.passwords.newPassword = "";
      this.passwords.confirmPassword = "";
    }
  },
  created() {
    this.$validator.localize("pt_BR");
  }
};
</script>

<style scoped>
.user-password {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  max-height: 35px;
}

img.eraser {
  max-height: 40px;
}
</style>
